module.exports = __webpack_public_path__ + "img/1F923.4d0fd70a.svg";